<template>
  <v-container>

    <StandardDialog v-if="bproletemplate_dialog" @click-outside="bproletemplate_dialog = false">
      <template #content>
        <v-card color="secondary" height="100%">
          <v-card-title>
            Importing Project Roles
          </v-card-title>
          <v-card-text>
            <v-list dense>
              <v-subheader>ROLE.templates</v-subheader>
              <!-- color="primary" -->
              <v-list-item-group
              v-model="selected_role_templates"
              multiple
              active-class="green"
              >
                <v-list-item
                v-for="bproletemplate in getUObjects({type: 'bproletemplates', ids: getUObject({type: 'businesses', id: getUser.business.id}).bproletemplates})"
                :key="`bproletemplates${bproletemplate.id}`"
                >
                  <template v-slot:default="{ active }">
                    <!-- <v-list-item-action>
                      <v-checkbox :input-value="active"></v-checkbox>
                    </v-list-item-action> -->
                    <v-list-item-content :input-value="active">
                      <v-list-item-title v-text="bproletemplate.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="addProlesFromTemplate()">Add Roles</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </StandardDialog>



    <v-row>
      <v-col class="xs-12 md-6">
        <v-card>
          <v-toolbar>
            <TText value="Members" font_weight="500" size="16"/>
            <v-spacer></v-spacer>
              <button style="margin-right: 10px" :class="`company-manage-filter-button ${show_filter ? 'primary' : 'color-3'}`" v-ripple
                @click="exportMembersAsCSV()">
                <TIcon name="download" :color="show_filter ? 'color-3' : 'primary'" />
              </button>
              <button :class="`company-manage-filter-button ${show_filter ? 'primary' : 'color-3'}`" v-ripple
                @click="show_filter = !show_filter">
                <TIcon name="filter" :color="show_filter ? 'color-3' : 'primary'" />
              </button>
          </v-toolbar>
          <div v-if="show_filter" class="company-manage-filter-container">
            <SearchBar :is_live_emit="true" @search="search = $event; setProjectMembersSelectedIndex(0)" />
            <DropDownOutlinedFlat label="Sort by" :options="sort_options" :value="sort" width="200"
              background_color="color-4" :foreground_color="$vuetify.theme.isDark ? '#fff' : '#000'"
              @change="sort = $event" />

          </div>
          <v-row>
            <v-col class="xs-5 members-setting-default-height">
              <ProjectMembersList :project_members="members" :current_user="getUser"/>
            </v-col>
            <v-col class="xs-7 members-setting-default-height">
              <ProjectMembersDetails :project_member="members[getProjectMembersSelectedIndex]" :project_id="this.project_id" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col class="xs-12 md-6">
        <v-card>
          <v-toolbar>
            <TText value="Invites" font_weight="500" size="16"/>
          </v-toolbar>
          <v-row>
            <v-col class="xs-7 members-setting-default-height">
              <ProjectInvitations
                :project_invitations="getProjectInvitations(project_id)"
                :project_proles="getUObjects({type: 'proles', ids: getUObject({type: 'projects', id: project_id}).proles})"
                :project_id="project_id"
                />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="xs-12">
        <v-card class="mb-10">
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3" style="display: flex; width: 100%;">
              {{$t('Project.Settings.Members.Roles.Title')}}
              <!-- text input field for ppermission_search -->
              <v-text-field
                v-model="ppermission_search"
                label="Filter Project Permissions"
                single-line
                hide-details
                class="ml-3"
                style="width: 200px;"
              ></v-text-field>
            </v-toolbar-title>
          </v-toolbar>
          
          <v-list>
            <v-list-group
              v-for="(prole, prole_index) in getUObjects({type: 'proles', ids: getUObject({type: 'projects', id: project_id}).proles})"
              :key="`proles${prole.id}`"
              :value="prole_show_index === prole_index"
              @input="prole_show_index = prole_index"
              no-action
            >
              <template #prependIcon>
                <v-list-item-action>
                  <v-btn icon @click.stop="add_is_active = !add_is_active">
                    <v-icon color="green">mode_edit</v-icon>
                  </v-btn>
                </v-list-item-action>
              </template>
              <template #appendIcon>
                <v-list-item-action style="display: flex; flex-direction: row-reverse; align-items: center;" >
                  <StandardDeleteBtn 
                    v-if="hasProjectPermission({project_id: project_id, ppermission: 'Delete Roles'})"
                    @deleteClick="deleteUObject({
                      url: [
                        { projects: project_id },
                        { proles: prole.id }
                      ]
                    })" />
                  <ButtonOutlined
                    value="Remove All"
                    color="warning"
                    width="80"
                    height="40"
                    text_size="8"
                    padding="3"
                    class="mr-3"
                    @click.native.stop="removeAllPermissions(prole)"
                  />
                  <ButtonOutlined
                    value="Add All"
                    color="success"
                    width="80"
                    height="40"
                    text_size="8"
                    padding="3"
                    class="mr-3"
                    @click.native.stop="addAllPermissions(prole)"
                  />
                </v-list-item-action>
              </template>

              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title v-text="prole.name"></v-list-item-title>
                  <v-list-item-subtitle v-text="prole.description"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
              <!-- v for over allpermissions filtered by ppermission_search -->
              <v-list-item
                v-for="ppermission in getUObjects({type: 'allppermissions'}).filter(ppermission => ppermission.name.toLowerCase().includes(ppermission_search.toLowerCase()))"
                :key="`ppermissions${ppermission.id}`"
                style="cursor: pointer;"
                :class="prole.ppermissions.indexOf(ppermission.id) !== -1 ? 'green' : ''"
                @click="prole.ppermissions.indexOf(ppermission.id) !== -1 ? removePPermission({project_id: project_id, prole_id: prole.id, ppermission_id: ppermission.id}) : addPPermission({project_id: project_id, prole_id: prole.id, ppermission_id: ppermission.id})"
              >
                <v-list-item-icon><v-icon v-if="prole.ppermissions.indexOf(ppermission.id) !== -1">done</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="ppermission.name"></v-list-item-title>
                  <v-list-item-subtitle v-text="ppermission.description"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item v-if="hasProjectPermission({project_id: project_id, ppermission: 'Update Roles'})">
              <v-list-item-icon>
                <v-icon v-if="!add_is_active" @click="add_is_active = true">add</v-icon>
                <v-icon v-if="add_is_active" @click="addNewRole()" color="green">send</v-icon>
              </v-list-item-icon>
              <v-list-item-content v-if="hasProjectPermission({project_id: project_id, ppermission: 'Add Roles'}) && !add_is_active" @click="add_is_active = true" style="cursor: pointer;">
                <v-list-item-title>NEW.role</v-list-item-title>
                <v-list-item-subtitle>Create a new project role.</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content v-if="hasProjectPermission({project_id: project_id, ppermission: 'Add Roles'}) && add_is_active">
                <v-list-item-title>
                  <StandardDataField text_color="primary" placeholder="ROLE.name" :value="new_role_name" @changeValue="new_role_name = $event" />
                </v-list-item-title>
                <v-list-item-subtitle>
                  <StandardDataField text_color="primary" placeholder="ROLE.description" :value="new_role_description" @changeValue="new_role_description = $event" />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="hasBusinessPermission('Add Roles')">
              <v-list-item-icon>
                <v-icon @click="bproletemplate_dialog = true">add</v-icon>
              </v-list-item-icon>
            <v-list-item-content  @click="bproletemplate_dialog = true" style="cursor: pointer;">
              <v-list-item-title>IMPORT.role</v-list-item-title>
              <v-list-item-subtitle>Import project roles from your company templates.</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import store from '@/store/index';
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue'
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue'
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
import ProjectMembersList from '@/components/ProjectSettings/ProjectMembersList.component.vue'
import ProjectMembersDetails from '@/components/ProjectSettings/ProjectMembersDetails.component.vue'
import ProjectInvitations from '@/components/ProjectSettings/ProjectInvitations.component.vue'
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import TText from '@/components/Taktify/TText.component.vue'
import TIcon from '@/components/Taktify/TIcon.component.vue'

import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';
import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';


import {
  mapGetters, mapActions
} from 'vuex';
export default {
  components: {
    StandardDataField, StandardDeleteBtn, ProjectMembersList,
    ProjectMembersDetails, ProjectInvitations, StandardDialog,
    ButtonOutlined, TText, TIcon, SearchBar, DropDownOutlinedFlat
  },
  name: 'ProjectMembers',
  data: function() {
    return {
      sort: '',
      search: '',
      show_filter: false,
      ppermission_search: '',
      selected_role_templates: [],
      prole_show_index: -1,
      add_is_active: false,
      new_role_name: '',
      new_role_description: '',
      bproletemplate_dialog: false
    }
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch('ProjectMember/requestProjectMembers', {
        project_id: to.params.project_id
      }),
      store.dispatch('Project/requestProjectInvites', {
        project_id: to.params.project_id
      }),
      store.dispatch('ProjectMember/requestPPermissions', {
        project_id: to.params.project_id
      }),
      store.dispatch('Ultra/requestUObject', {
        url: [
          { projects: to.params.project_id },
          { proles: '' },
          { showWithEntitiesNormalized: '' }
        ]
      })
    ])
    .then(res => {
      next(res);
    });
  },
  created(){
    if (this.hasBusiness !== -1) {
      store.dispatch('Ultra/requestUObject', {
        url: [
          {businesses: this.getUser.business.id},
          {bproletemplates: ''},
          {showWithEntitiesNormalized: ''}
        ]
      });
    }
  },
  computed: {
    project_id() { return this.$route.params.project_id; },
    ...mapGetters('View', [
      'getProjectMembersSelectedIndex',
    ]),
    ...mapGetters('Project', [
      'getProjectInvitations',
      'getProjectProles',
      'hasProjectPermission'
    ]),
    ...mapGetters('Business', [
      'getBusiness',
      'hasBusinessPermission'
    ]),
    ...mapGetters('ProjectMember', [
      'getProjectMembers',
    ]),
    ...mapGetters('Auth', [
      'getUser',
    ]),
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects'
    ]),
    members() {
      let terms = this.search.split(' ');
      let ret = this.getProjectMembers(this.project_id);
      let sort = this.sort.split('-');
      if (sort[0]) {
        this.sortObjectArrayByValueOfKey(ret, sort[0]);
        if (sort[1] == 'dsc') {
          ret.reverse();
        }
      }
      else if (sort[0] === '') {
        ret.sort(function (a, b) { return a.usersbusiness_id - b.usersbusiness_id });
      }

      terms.forEach(term => {
        ret = ret.filter(element =>
          element.first_name.toLowerCase().includes(term.toLowerCase()) ||
          element.last_name.toLowerCase().includes(term.toLowerCase()) ||
          element.email.toLowerCase().includes(term.toLowerCase())
        )
      });
      return ret;
    },
    sort_options() {
      return [
        { value: '', text: '' },
        { value: 'first_name-asc', text: 'First Name (a-z)' },
        { value: 'first_name-dsc', text: 'First Name (z-a)' },
        { value: 'last_name-asc', text: 'Last Name (a-z)' },
        { value: 'last_name-dsc', text: 'Last Name (z-a)' },
        { value: 'email-asc', text: 'Email (a-z)' },
        { value: 'email-dsc', text: 'Email (z-a)' },
      ];
    },
  },
  methods: {
    ...mapActions('ProjectMember', [
      'removePPermission',
      'addPPermission'
    ]),
    ...mapActions('Ultra', [
      'createUObject',
      'deleteUObject'
    ]),
    ...mapActions('View', [
      'setProjectMembersSelectedIndex',
    ]),
    exportMembersAsCSV() {
      let csv = {}
      this.members.forEach(member => {
        csv[member.id] = {
          name: member.first_name + ' ' + member.last_name,
          email: member.email,
          role: member.prole.name
        }
      })
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += "name,email,role\r\n";
      Object.values(csv).forEach(function(rowObject) {
          let row = Object.values(rowObject).join(",");
          csvContent += row + "\r\n";
      });
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "project_members.csv");
      document.body.appendChild(link);
      link.click();
    },
    sortObjectArrayByValueOfKey(array, sort_key) {
      array.sort((a, b) => {
        // we check every char if they're the same, if not sort accordingly
        // TODO: check for ö, ä, ü, ß
        let min = Math.min(a[sort_key].length, b[sort_key].length);
        for (let i = 0; i < min; i++) {

          if (a[sort_key][i].toLowerCase() !== b[sort_key][i].toLowerCase()) {
            return a[sort_key][i].toLowerCase() > b[sort_key][i].toLowerCase() ? 1 : -1;
          }
        }

        // all chars were the same, shorter string is prioritized
        if (a[sort_key].length != b[sort_key].length) {
          return a[sort_key].length === min ? -1 : 1;
        }

        // string matches exactly, no preference
        return 0;
      });
    },
    addAllPermissions(prole){
      this.getUObjects({type: 'allppermissions'}).forEach((ppermission) => {
        if(prole.ppermissions.indexOf(ppermission.id) === -1) {
          this.addPPermission({project_id: this.project_id, prole_id: prole.id, ppermission_id: ppermission.id});
        }
      });
    },
    removeAllPermissions(prole){
      this.getUObjects({type: 'allppermissions'}).forEach((ppermission) => {
        if(prole.ppermissions.indexOf(ppermission.id) !== -1) {
          this.removePPermission({project_id: this.project_id, prole_id: prole.id, ppermission_id: ppermission.id});
        }
      });
    },
    addProlesFromTemplate(){
      let self = this;
      let promises = [];

      let templates = this.getUObjects({type: 'bproletemplates', ids: this.getUObject({type: 'businesses', id: this.getUser.business.id}).bproletemplates});
      this.selected_role_templates.forEach((item) => {

        let ppermissions = [];
        for (let j = 0; j < templates[item].ppermissions.length; j++) {
          ppermissions.push({id: templates[item].ppermissions[j]});
        }

        promises.push(this.createUObject({
          url: [
            { projects: this.project_id },
            { proles: '' },
            { showWithEntitiesNormalized: '' }
          ],
          u_object: {
            name: templates[item].name,
            description: templates[item].description,
            ppermissions: ppermissions
          }
        }));


      });

      Promise.all(promises)
      .then(() => {
        self.bproletemplate_dialog = false;
      });

    },
    addNewRole(){
      let self = this;
      this.createUObject({
        url: [
          { projects: this.project_id },
          { proles: '' },
          { showWithEntitiesNormalized: '' }
        ],
        u_object: {
          name: self.new_role_name,
          description: self.new_role_description,
          ppermissions: []
        }
      }).then( () => {
        self.add_is_active = false;
        self.new_role_name = '';
        self.new_role_description = '';
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.members-setting-default-height {
  max-height: 600px;
  overflow-y: auto;
}
.company-manage-filter-button {
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.company-manage-filter-container {
  height: 64px;
  width: 100%;
  display: flex;
  grid-gap: 36px;
  align-items: center;
}
</style>
